export default __webpack_public_path__ + "static/media/geoserver-icon.2a115b7d.svg";